export default __webpack_public_path__ + "static/media/generated_Multiforme_1741_Bathroom_Opale_Green_Ama_Mica_AsP0q1f.jpg.1400x1400_q85.d9295ef1.jpg";